/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import { consultaReducer } from './consulta/reducers'
import { stepBarReducer } from './stepbar/reducers'
import { excecaoReducer } from './excecao/reducers'
import { acessoLogadoReducer } from './acessoLogado/reducers'
import { errorReducer } from './error/reducer'

const rootReducer = combineReducers({
  consulta: consultaReducer,
  stepbar: stepBarReducer,
  excecao: excecaoReducer,
  acessoLogado: acessoLogadoReducer,
  error: errorReducer
})

export type AppState = ReturnType<typeof rootReducer>

const composeEnhancers: any =
  process.env.REACT_APP_NODE_ENV !== 'production'
    ? composeWithDevTools
    : compose

export default function configureStore() {
  const middlewares = [thunkMiddleware]
  const middleWareEnhancer = applyMiddleware(...middlewares)

  return createStore(rootReducer, composeEnhancers(middleWareEnhancer))
}

export const store = configureStore()
